module.exports = __webpack_public_path__ + "static/media/calendar.b496472c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/calendar.svg
// module id = 238
// module chunks = 7